import React, { useState, useEffect } from "react";
import axios from "axios";
import KeyboardArrowLeftRoundedIcon from "@mui/icons-material/KeyboardArrowLeftRounded";

function Feeds() {
  const [data, setData] = useState([]);
  const dvid = [
    "https://cdn.wbcamateurmuaythaiindia.com/minf-minf/(yo)/AQP2KVgR90A-NIvIWNDklBODcbRx0QPxJjyF6GOJN7BWIcADbvPnKxvftClyPCz3qZylYjNhsvpAuejYc0iAeW3W7HngzM7gzMenFmsE2v3HLw.mp4",
    "https://cdn.wbcamateurmuaythaiindia.com/minf-minf/(yo)/AQNQB0wGeC_4OHVRYc0t3esWbga9r2bwrEyHtTzeny9rVEDkDg8HOd1av23s77wZdE4Mg7hl-3BPO1hD4fnVevM.mp4",
    "https://cdn.wbcamateurmuaythaiindia.com/minf-minf/(yo)/AQPZ0Lk2URld4a7o_sjfEEFOu1CNOVEy9yL4eJTcy_6eguvejX4ysuHkwuogInbEMRlNO8FPVa0tqCd2-_F--mo4.mp4",
    "https://cdn.wbcamateurmuaythaiindia.com/minf-minf/(yo)/AQOySYxWynviuyKeHPlyI6jh5mIzzCQvEHdul2mWwi37Elz6nHEa4JrDIs9xfSpaa6c6VTZUbBvZ_bxmIiRoQWbM.mp4",
  ]

  useEffect(() => {
    async function fetchData() {
      try {
        const response = await axios.get(
          `https://graph.facebook.co/me?field=first_name,posts{source,type}&access_token=${process.env.REACT_APP_FACEBOOK_GRAPH_TOKEN}`
        );
        if (response.data.posts && response.data.posts.data) {
          let arrvideo = response.data.posts.data.filter((e) => e.type === "video");
          setData(arrvideo.slice(0, 4));
        }
      } catch (error) {
        setData(dvid);
        console.error("Error fetching data:", error);
      }
    }
    fetchData();
  }, []);

  return (
    <div className="h-full w-full grid grid-flow-col gap-3 overflow-x-scroll mb-12">
      <div
        className={`h-full md:w-[90px] md:mr-8 w-[100px] text-center flex gap-1 text-gray-700 text-xl md:text-3xl justify-center items-center thermite `}
      >
        <div className="mt-[-8px]">
          <KeyboardArrowLeftRoundedIcon />
        </div>
        VIDEO
      </div>
      {data.map((e, index) => (
            <div
              key={index}
              className={`h-[70vh] bg-green-200 w-[300px] rounded-md`}
            >
              <video
                className="w-full h-full object-cover rounded-md"
                muted
                controls
                loop
                autoPlay={index === 0 ? true : false}
              >
                <source
                  src={
                    e.source ? e.source : e
                  }
                  type="video/mp4"
                  preload="metadata"
                />
              </video>
            </div>
          ))}
    </div>
  );
}

export default Feeds;
